export const isAppleMobileDevice = (
  device = typeof navigator !== "undefined" ? navigator : {}
) => {
  const userAgent = String(device.userAgent || "");
  const platform = String(device.platform || "");
  const touchPoints = Number(device.maxTouchPoints || 0);

  return (
    /iPad|iPhone|iPod/i.test(userAgent) ||
    ((platform === "MacIntel" || /Macintosh/i.test(userAgent)) &&
      touchPoints > 1)
  );
};
